import { api } from '../root';
import { JoyrideStatus, UpdateJoyrideStatusRequest, UpdateJoyrideStatusResponse, JoyrideTourKey } from './types';
import { handleRequestErrors } from 'helpers/functions/commons';

/**
 * Get the current user's joyride status
 * @returns Object with tour keys and their completion status
 */
export const getJoyrideStatus = async (): Promise<JoyrideStatus> => {
    try {
        const response = await api.get<JoyrideStatus>('/Account/joyride-status');
        return response.data;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e);
        console.error('Error fetching joyride status:', validationMessage);
        // Return empty object as fallback
        return {};
    }
};

/**
 * Update a specific tour's completion status for the current user
 * @param tourKey The tour identifier
 * @param completed Whether the tour is completed
 * @returns Updated joyride status
 */
export const updateJoyrideStatus = async (
    tourKey: JoyrideTourKey,
    completed: boolean
): Promise<JoyrideStatus> => {
    try {
        const payload: UpdateJoyrideStatusRequest = { tourKey, completed };
        const response = await api.put<UpdateJoyrideStatusResponse>(
            '/Account/joyride-status',
            payload
        );
        return response.data.joyrideStatus;
    } catch (e: unknown) {
        const validationMessage = handleRequestErrors(e);
        console.error('Error updating joyride status:', validationMessage);
        throw e;
    }
};

/**
 * Reset a specific tour (mark as not completed)
 * @param tourKey The tour identifier to reset
 * @returns Updated joyride status
 */
export const resetJoyrideTour = async (tourKey: JoyrideTourKey): Promise<JoyrideStatus> => {
    return updateJoyrideStatus(tourKey, false);
};
